import { apiGet } from './client';

export function searchUsers(query, limit = 10, offset = 0, skill = '') {
  const q = encodeURIComponent(query);
  const skillPart = skill.trim()
    ? `&skill=${encodeURIComponent(skill.trim())}`
    : '';
  return apiGet(`/search/users?q=${q}&limit=${limit}&offset=${offset}${skillPart}`);
}

export function searchTeams(query, limit = 10, offset = 0) {
  const q = encodeURIComponent(query);
  return apiGet(`/search/teams?q=${q}&limit=${limit}&offset=${offset}`);
}

export function searchAll(query, limitPerScope = 10, skill = '') {
  const q = encodeURIComponent(query);
  const skillPart = skill.trim()
    ? `&skill=${encodeURIComponent(skill.trim())}`
    : '';
  return apiGet(`/search?q=${q}&limit_per_scope=${limitPerScope}${skillPart}`);
}

export function listWantTeamUsers({ query = '', limit = 20, offset = 0, skill = '' } = {}) {
  const params = new URLSearchParams();
  if (query) params.set('q', query);
  if (skill) params.set('skill', skill);
  params.set('limit', String(limit));
  params.set('offset', String(offset));
  return apiGet(`/search/users/want-team?${params.toString()}`);
}

export function getSearchUserProfile(userId) {
  return apiGet(`/search/users/${userId}`);
}

export function getSearchTeamProfile(teamId) {
  return apiGet(`/search/teams/${teamId}`);
}
